module.exports = __webpack_public_path__ + "static/media/halele.3ddbc9b0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/halele.gif
// module id = 228
// module chunks = 0